import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQuickSearch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconQuickSearch"><Path d="M12 3.5C7.85786 3.5 4.5 6.85786 4.5 11H3C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 13.2153 20.1996 15.2436 18.8723 16.8116L22.0303 19.9697L20.9697 21.0303L17.8116 17.8723C16.2436 19.1996 14.2153 20 12 20V18.5C16.1421 18.5 19.5 15.1421 19.5 11C19.5 6.85786 16.1421 3.5 12 3.5Z" fill="currentColor"/><Path d="M8.78571 10L3 16.875H6.85714L6.21429 21L12 14.125H8.14286L8.78571 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconQuickSearch;
